import React, { useContext } from "react";
import ImgTag from "../Helpers/ImgTag";
import { ModalContext } from "@/pages/_app";
import { useRouter } from "next/router";

function truncateToTwoDecimalPlaces(number) {
  const formattedNumber = Number(number);
  return formattedNumber.toFixed(2);
}

const TabbyWidget = ({ price, locale, installments = 4 }) => {
  console.log("installments", installments, price);
  const Context = useContext(ModalContext);
  const { pathname } = useRouter();
  return (
    !pathname.startsWith("/success") && (
      <div className="border px-1 p-1.5 rounded-md flex items-center my-2">
        <ImgTag
          src={`${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/20080&h=36,fit=contain,format=auto,quality=100/tabby.png`}
          // className="h-[32px] w-auto object-cover rounded-md"
          className="h-[35px] w-auto object-contain"
          height={120}
          width={120}
          alt=""
        />
        <p className="mx-4 flex items-center flex-col">
          <span>
            {locale === "en"
              ? `or Split it into ${installments} payments of ${
                  truncateToTwoDecimalPlaces((price || 0) / installments) || ""
                } SAR interest-free`
              : `أو قسّمها على ${installments} دفعات بقيمة ${
                  truncateToTwoDecimalPlaces((price || 0) / installments) || ""
                } رس. بدون أي فوائد أو رسوم. `}
            <span
              className="underline cursor-pointer mx-0.5 font-semibold"
              onClick={() =>
                Context?.dispatch({
                  type: "tabbyModal",
                  payload: {
                    installments,
                    price: truncateToTwoDecimalPlaces(price || 0),
                  },
                })
              }
            >
              {locale === "en" ? "Learn more" : "اعرف المزيد"}
            </span>
          </span>
        </p>
      </div>
    )
  );
};

export default TabbyWidget;
